import { groupBy, concat, get } from 'lodash'
import { app as api } from '@ekuaibao/whispered'
/***************************************************
 * Created by nanyuantingfeng on 2020/4/21 00:45. *
 ***************************************************/
import { calcDetailsAmount, getNodeValueByPath, calcDetailsReceivingAmount } from '@ekuaibao/lib/lib/lib-util'
import { MoneyMath } from '@ekuaibao/money-math'
import { standardValueMoney } from '../../../lib/misc'
import Big from 'big.js'

const title = formType => {
  if (formType === 'expense') {
    return i18n.get('报销金额')
  }
  if (formType === 'requisition') {
    return i18n.get('申请金额')
  }
  if (formType === 'loan') {
    return window.IS_SMG ? i18n.get('预支金额') : i18n.get('借款金额')
  }
  if (formType === 'settlement') {
    return i18n.get('结算金额')
  }
  if (formType === 'receipt') {
    return i18n.get('收款金额')
  }
}

function total(list = []) {
  return list.reduce((a, b) => new MoneyMath(a).add(b).fixedValue, 0)
}

export function getDetailCalculateMoney(details = [], formType, allowSelectionReceivingCurrency) {
  const dimentionCurrencyInfo = api.getState()['@bills']?.dimentionCurrencyInfo
  const standardCurrency = api.getState()['@common']?.standardCurrency
  const currency = dimentionCurrencyInfo?.currency ?? standardCurrency // 当前单据的本位币
  const handleMoney = items => {
    const money = calcDetailsAmount(items)
    if (allowSelectionReceivingCurrency) {
      const receivingAmount = calcDetailsReceivingAmount(items)

      // 提单人视角
      if (receivingAmount?.standardNumCode !== money?.standardNumCode) {
        if (!receivingAmount) {
          return standardValueMoney(0, currency)
        }
        return {
          foreign: receivingAmount?.standard,
          foreignNumCode: receivingAmount?.standardNumCode,
          foreignSymbol: receivingAmount?.standardSymbol,
          foreignUnit: receivingAmount?.standardUnit,
          foreignScale: receivingAmount?.standardScale,
          foreignStrCode: receivingAmount?.standardStrCode,
          standard: money?.standard,
          standardStrCode: money?.standardStrCode,
          standardNumCode: money?.standardNumCode,
          standardSymbol: money?.standardSymbol,
          standardUnit: money?.standardUnit,
          standardScale: money?.standardScale,
          rate: new Big((money?.standard || 0) / (Number(receivingAmount?.standard) || 0.001)).toFixed(32),
          allowReceivingCurrency: true
        }
      }
      // 只展示本位币
      return {
        standard: money?.standard || 0,
        standardStrCode: money?.standardStrCode,
        standardNumCode: money?.standardNumCode,
        standardSymbol: money?.standardSymbol,
        standardUnit: money?.standardUnit,
        standardScale: money?.standardScale,
        allowReceivingCurrency:
          money?.standardNumCode !== receivingAmount?.standardNumCode && Boolean(money?.foreignNumCode)
      }
    }
    return money
  }

  const detailTotalMoney = handleMoney(details)

  const detailsTotal = {
    label: title(formType),
    money: detailTotalMoney
  }

  const companyPayMoney = total(details.map(v => v.feeTypeForm.companyRealPay).filter(o => o))
  if (formType !== 'loan') {
    const settlementMoneyObject = groupBy(details, item => {
      return item.feeTypeForm.settlement && item.feeTypeForm.settlement.opportunity
    })
    const settlementGroup = groupBy(
      details.filter(item => !!item.feeTypeForm.settlement),
      item => {
        return item.feeTypeForm.settlement && item.feeTypeForm.settlement.name
      }
    )
    const expenseDetails = concat(
      settlementMoneyObject['SINGLEPAYMENT'] || [],
      settlementMoneyObject.undefined || [],
      settlementMoneyObject[''] || [],
      settlementMoneyObject.null || []
    )
    let expenseMoney = handleMoney(expenseDetails)
    let settlements = []
    Object.keys(settlementGroup)
      .filter(name => !!name)
      .forEach(name => {
        const items = settlementGroup[name]
        const opportunity = getNodeValueByPath(items[0], 'feeTypeForm.settlement.opportunity')
        const money = handleMoney(items)
        settlements.push({
          value: money,
          items,
          label: name,
          opportunity,
          showNegative: formType === 'expense'
        })
      })
    if (formType === 'expense') {
      settlements = settlements.filter(item => item.opportunity !== 'SINGLEPAYMENT')
    }
    return {
      detailsTotal,
      companyPayMoney,
      payDetail: {
        lable: '',
        value: expenseMoney,
        items: expenseDetails
      },
      settlements
    }
  }
  return {
    detailsTotal,
    companyPayMoney,
    payDetail: {
      lable: '',
      items: details,
      value: handleMoney(details)
    }
  }
}

export function getCalculateReimbursementMoney(details, value) {
  const { payMoney } = value
  return {
    reimbursementMoney: payMoney
  }
}

export default getDetailCalculateMoney
